import { render, staticRenderFns } from "./order.vue?vue&type=template&id=290a71de&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=290a71de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a71de",
  null
  
)

export default component.exports